export enum UserFunction {
  SELLER = 1,
  MANAGER_SELLER = 2,
  MANAGER_MARKETING = 3,
  CUSTOMER_SERVICE = 4,
  FINANCIAL_OFFICER = 5,
  PRESIDENT = 6,
  DEVELOPER = 7,
  MANAGER_WAREHOUSE = 8,
  ORDER_PICKER = 9,
  MANAGER_WEBMARKETING = 10,
  EXECUTIVE_OFFICER = 11,
  B2b_MANAGER = 12,
  PURCHASING_DIVISION = 13,
  MANAGER_RETAIL = 14,
}
